export default function getStyles(height, size) {

  switch (size) {
    case "sm_vertical":
      return {paddingBottom: height ? "60px" : "0"};
    default:
      return { paddingBottom: height ? "60px" : "0", display: "flex", justifyContent: "space-between", flexWrap: "wrap" };
  }
}